import { ExternalUser, SalesPerson } from "models/customers/customers";
import UserServiceEdit from "./UserServiceEdit";
import UserServicesSummary from "./UserServicesSummary";

type Props = {
  isInternal: boolean;
  summaryTitle: string;
  editTitle: string;
  fpConfig: any;
  disableFp?: boolean;
  onSetFpService: (customerChoice: string, userId: string) => void;
  onToggleService: (userId: string, serviceId: string, value: boolean) => void;
  onToggleChildServices: (
    userId: string,
    serviceIds: string[],
    value: boolean
  ) => void;
  users?: ExternalUser[] | SalesPerson[];
  collapsed?: boolean;
};

export default function UserService({
  isInternal,
  summaryTitle,
  editTitle,
  fpConfig,
  disableFp,
  onSetFpService,
  onToggleService,
  onToggleChildServices,
  users,
  collapsed
}: Props) {
  const visibleModule = collapsed ? (
    <UserServicesSummary
      isInternal={isInternal}
      fpConfig={fpConfig}
      title={summaryTitle}
      disableFp={disableFp}
    />
  ) : (
    <UserServiceEdit
      isInternal={isInternal}
      showSaveButton={collapsed}
      title={editTitle}
      users={users ?? []}
      fpConfig={fpConfig}
      onSetFpService={onSetFpService}
      onToggleService={onToggleService}
      onToggleChildServices={onToggleChildServices}
      disableFp={disableFp}
    />
  );

  return <div>{visibleModule}</div>;
}
